import { useCallback, useEffect } from "preact/hooks";
import useAxios from "../../hooks/useAxios";


export default function useTransactionInfo(service_name, session_id) {

    const { data: transactionInfo, isLoading, fetch } = useAxios();

    const fetchTransactionInfo = useCallback((config) => {
        const session_id = config?.params?.session_id;
        const targetUrl = `/user/reports/profile/session/${service_name}/${session_id}`;
        const requestParams = { method: "GET", ...config };
        return fetch(targetUrl, requestParams);
    }, []);

    useEffect(() => fetch(`/user/reports/profile/session/${service_name}/${session_id}`), []);

    return { isLoading, transactionInfo, fetchTransactionInfo };
}